import { render } from "./embedded-dashboard.vue?vue&type=template&id=46f922e4&ts=true"
import script from "./embedded-dashboard.ts?vue&type=script&lang=ts&external"
export * from "./embedded-dashboard.ts?vue&type=script&lang=ts&external"

import "./embedded-dashboard.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__